/* global __APP_VERSION__ */
import '../notAvailable/index.scss';

import React from 'react';
import { connect } from 'react-redux';

@connect((store) => {
  return {
    user: store.loggedUser.data,
    project: store.project,
    reminder: store.reminder,
    loggedUser: store.loggedUser,
  };
})
export default class Error404 extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div class="no-project error404">
        <div class="no-project-content">
          <div class="logo logo-header">
            <img
              src="/images/cloudcfo-logo-colored-icon-beside-text.png"
              class="img-responsive"
              style={{ height: '27px' }}
            />
          </div>

          <div class="">
            <p class="header-title">404 Error</p>
            <p class="content-message">
              The requested URL was not found on this server.
            </p>
          </div>

          <div class="mt50">
            <span
              style={{ color: '#999999', fontSize: '18px' }}
            >{`App version: ${__APP_VERSION__}`}</span>
          </div>
        </div>
      </div>
    );
  }
}
